import { Maybe } from "~/types/types.util"

export const generateUrlWithQuery = (pathOrUrl: string,
  params: string | string[][] | Record<string, string> | URLSearchParams | undefined): string => {
  const endpoint = new URL(pathOrUrl, window.location.origin)
  const searchParams = new URLSearchParams(params)
  endpoint.search = searchParams.toString()
  return endpoint.toString()
}

export const collectionIdFromUrl = (): Maybe<number> => {
  const match = window.location.pathname.match(/\/collections\/(\d+)/)?.[1]
  if (match) {
    const numeric = +match
    if (Number.isNaN(numeric)) {
      throw new Error(`Collection ID was expected to be numeric, but was ${match}`)
    }
    return numeric
  }
}
